import { AfterViewInit, Component, ElementRef, Injector, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Rxjs
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';

// Shared
import { ONBOARDING_CARD_ENUMERATION } from '../shared';
import { ROUTES_CONSTANTS } from '@shared/configs';
import { DISPERSION_METHOD_COMPONENTS_CONSTANT } from '@credit/dispersion-method';

@Component({
  selector: 'app-card-explain',
  templateUrl: './card-explain.component.html',
})
export class CardExplainComponent implements AfterViewInit, OnDestroy {
  @ViewChild('onboardingViews', { static: false }) public onboardingViews: ElementRef;

  private readonly webComponentService: WebcomponentsService;
  private router: Router;
  private readonly unSubscribe$: Subject<void>;
  private readonly ngZone: NgZone;
  private readonly activatedRoute: ActivatedRoute;

  constructor(private readonly injector: Injector) {
    this.router = this.injector.get(Router);
    this.webComponentService = this.injector.get(WebcomponentsService);
    this.unSubscribe$ = new Subject<void>();
    this.ngZone = this.injector.get(NgZone);
    this.activatedRoute = this.injector.get(ActivatedRoute);
  }

  public ngAfterViewInit(): void {
    this.renderOnboardingViews();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private renderOnboardingViews(): void {
    const onboardingViews = this.onboardingViews.nativeElement;
    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          onboardingViews.ngElementStrategy?.componentRef?.instance?.build({
            onboardingView:
              this.activatedRoute.snapshot.queryParams['viewname'] ?? ONBOARDING_CARD_ENUMERATION.CARD_EXPLAIN,
            continueActionFn: this.continueAction.bind(this),
            backActionFn: this.backAction.bind(this),
          });
        }
      },
    });
  }

  public continueAction({ currentViewname }: { currentViewname: string }): void {
    if (currentViewname === ONBOARDING_CARD_ENUMERATION.CARD_TERMS_AND_CONDITIONS) {
      this.ngZone.run(() => {
        this.router.navigate([`/${ROUTES_CONSTANTS.DISPERSION_METHOD}`], {
          queryParams: {
            viewname: DISPERSION_METHOD_COMPONENTS_CONSTANT.DISPERSION_SELECT_OPTION,
          },
        });
      });
    }
  }

  public backAction(): void {
    this.ngZone.run(() => {
      this.router.navigate([`/${ROUTES_CONSTANTS.DISPERSION_METHOD}`]);
    });
  }
}
